import { BulkEditLocationRequest, PartRequestBulkItemDto } from '../types';

export const createLocationRequest = (row: PartRequestBulkItemDto): BulkEditLocationRequest => {
  return {
    lineId: row.lineId,
    location: row.location,
    selected: false,
  };
};
